import React from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'

import LinkButton from '~/components/Buttons/LinkButton'
import * as ROUTES from '~/constants/routes'

import ActionButtons from './ActionButtons'

import { IFrameStyled } from '../styled/IFrame.styled'

function WarehouseImportStep ({ onSkip }) {
  return (
    <Box>
      <Typography variant="h5" gutterBottom={true}>
        Set up warehouse
      </Typography>
      <Box>
        <IFrameStyled
          src="https://www.youtube.com/embed/4zHYN9iB8yI"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        />
      </Box>
      <ActionButtons onSkip={onSkip}>
        <LinkButton href={ROUTES.WAREHOUSE_IMPORT_PATH} target="_blank">Set up</LinkButton>
      </ActionButtons>
    </Box>
  )
}

WarehouseImportStep.propTypes = {
  onSkip: PropTypes.func.isRequired
}

export default WarehouseImportStep
